import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

export interface ListLinesSkeletonProps {
  lines?: number;
}

/**
 * Simple vertical list of text-line placeholders (forms, sidebars, menus).
 */
export const ListLinesSkeleton: React.FC<ListLinesSkeletonProps> = ({ lines = 4 }) => (
  <Box sx={{ width: '100%', py: 1 }} role="status" aria-label="Loading list">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        variant="text"
        animation={SKELETON_ANIMATION}
        height={20}
        width={i === lines - 1 ? '60%' : '100%'}
        sx={{ mb: 1, ...skeletonTintSx }}
      />
    ))}
  </Box>
);
